import { Text, addWithConfig } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Link from 'components/link';

export const DeliveryTermsText = Text.withConfig({
  fontSize: 'md',
  textAlign: 'center',
});

export const TermsLink = Link.withConfig({
  fontSize: 'md',
  isUnderlined: true,
});

export const TermsButton = addWithConfig(ActionButton).withConfig({
  variant: ActionButtonVariants.TEXT_ONLY,
  fontSize: 'md',
  padding: 0,
});
